export default function AppSection() {
  return (
    <section id="app" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-10">
          羞羞歪歪漫画APP下载
        </h2>
        <div className="max-w-4xl mx-auto">
          <div className="bg-gradient-to-br from-primary-500/8 via-accent-500/8 to-primary-500/5 rounded-2xl p-8 md:p-12 border border-primary-200/30">
            <div className="flex flex-col lg:flex-row items-center gap-8">
              <div className="flex-shrink-0 w-32 h-32 md:w-40 md:h-40 rounded-2xl bg-gradient-to-br from-primary-400 to-primary-600 flex items-center justify-center shadow-lg shadow-primary-500/20">
                <i className="ri-smartphone-line text-5xl md:text-6xl text-background-50"></i>
              </div>
              <div className="flex-1 text-center lg:text-left">
                <h3 className="text-xl md:text-2xl font-heading text-foreground-900 mb-3">
                  羞羞歪歪漫画移动客户端
                </h3>
                <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6">
                  专为漫画阅读优化的移动端应用，支持下拉式竖屏阅读模式，流畅翻页体验。全部章节无删减，与网页版同步更新。离线缓存功能让您随时随地畅享精彩漫画，羞羞歪歪漫画在线看入口一键直达。
                </p>
                <div className="flex flex-wrap items-center justify-center lg:justify-start gap-3">
                  <a
                    href="#app"
                    className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-apple-fill text-lg"></i>
                    iOS 下载
                  </a>
                  <a
                    href="#app"
                    className="inline-flex items-center gap-2 px-6 py-2.5 bg-foreground-900 hover:bg-foreground-800 text-background-50 rounded-full text-sm font-medium transition-colors cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-android-fill text-lg"></i>
                    Android 下载
                  </a>
                  <a
                    href="#app"
                    className="inline-flex items-center gap-2 px-6 py-2.5 border border-foreground-300 hover:border-primary-400 hover:text-primary-500 text-foreground-600 rounded-full text-sm font-medium transition-all cursor-pointer whitespace-nowrap"
                  >
                    <i className="ri-qr-code-line text-lg"></i>
                    扫码下载
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}